// extracted by mini-css-extract-plugin
module.exports = {"stream":"Stream_stream__3GX6C","controls":"Stream_controls__2xmR7","edit":"Stream_edit__BVrcv"};